'use client';
import e__default, { useEffect } from 'react';
import { searchInputPropTypes, SearchInput } from '../search-input/search-input.component.js';
import { ComboboxInput } from './combobox-input.component.js';
import { useSwanComboboxContext } from './combobox.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
const ComboboxSearchInput = renderWithRef('ComboboxSearchInput', searchInputPropTypes, (n, i)=>{
    let { inputRef: b, triggerRef: u, setInputValue: l } = useSwanComboboxContext(), { overlayState: m } = useSwanPopover(), f = assignRefs(i, b), getSearchInputProps = (e)=>_object_spread_props(_object_spread({}, e), {
            onClear: (e)=>{
                var r;
                null === (r = n.onClear) || void 0 === r || r.call(n, e), l('');
            }
        });
    return useEffect(()=>{
        let e = b.current, cb = (e)=>{
            let r = m.selectionManager.focusedKey;
            if ('Enter' === e.key && !r) {
                var t;
                let e = null === (t = u.current) || void 0 === t ? void 0 : t.querySelector('button[type="submit"]');
                null == e || e.click();
            }
        };
        return null == e || e.addEventListener('keydown', cb), ()=>null == e ? void 0 : e.removeEventListener('keydown', cb);
    }, [
        b,
        u,
        m
    ]), e__default.createElement(RenderComp, {
        root: "div",
        forwardedRef: u,
        classNames: [
            'swan-combobox-search-input-container'
        ],
        props: {}
    }, e__default.createElement(ComboboxInput, _object_spread_props(_object_spread({}, n), {
        ref: f,
        render: (r, t)=>e__default.createElement(RenderComp, {
                root: SearchInput,
                forwardedRef: t,
                props: getSearchInputProps(r)
            })
    })));
});

export { ComboboxSearchInput };
